import actions from "./actions";
import { takeEvery, put } from "redux-saga/effects";
import userUrls from "src/infinode/constants/urls/userUrls";
import siteConfig from "@iso/config/site.config";
import {
  getPostRequestInfo,
  getRequestGeneratorFunction
} from "@iso/utils/connectUtils";
import appActions from "../app/actions";
import { createBrowserHistory } from "history";
import localStorageUtils from "@iso/lib/helpers/localStorageUtils";

const { signIn, testUser, testPassword } = userUrls;

const history = createBrowserHistory();

const onSignInRequest = ({ username = testUser, password = testPassword }) =>
  fetch(
    `${siteConfig.apiUrl}${signIn}`,
    getPostRequestInfo({ username: username, password: password })
  );

const onSignInSuccess = function* (resultBody) {
  if (resultBody.accessToken) {
    yield put({
      type: actions.INFI_LOGIN_SUCCESS,
      accessToken: resultBody.accessToken,
      userId: resultBody.userId
    });
    return true;
  }
  return false;
};

const loginRequest = getRequestGeneratorFunction(
  actions.INFI_LOGIN_REQUEST,
  actions.INFI_LOGIN_ERROR,
  onSignInRequest,
  onSignInSuccess
);

function* loginSuccess() {
  yield takeEvery(actions.INFI_LOGIN_SUCCESS, function* ({
    accessToken,
    userId
  }) {
    yield localStorageUtils.setLoginInfo(accessToken, userId);
    yield appActions.clearMenu();
    yield history.push("/dashboard");
  });
}

function* loginError() {
  yield takeEvery(actions.INFI_LOGIN_ERROR, function* ({ error }) {
    yield console.log(`Login error`);
    yield console.log(error);
  });
}

function* logout() {
  yield takeEvery(actions.INFI_LOGOUT, function* () {
    yield localStorageUtils.clearLoginInfo();
    history.push("/");
  });
}

export default { loginRequest, loginSuccess, loginError, logout };
